import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { GenesysCloudExternalContactEffects } from './effects/external-contact.effects';
import { GenesysCloudExternalContactNotificationEffects } from './effects/external-contact-notifications.effects';
import { genesysCloudExternalContactsReducer } from './reducers/external-contact.reducers';
import { featureKey } from './reducers/feature-key';

@NgModule({
  imports: [
    StoreModule.forFeature(featureKey, genesysCloudExternalContactsReducer),
    EffectsModule.forFeature([
      GenesysCloudExternalContactEffects,
      GenesysCloudExternalContactNotificationEffects
    ])
  ]
})
export class GenesysCloudExternalContactsModule {
}
